import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { getWorkspaceRoomId } from "../utils/callRoom";
import { logger } from "../utils/logger";

const callDocRef = (problemId) =>
  doc(db, "calls", getWorkspaceRoomId(problemId));

const iceCollectionRef = (problemId) =>
  collection(db, "calls", getWorkspaceRoomId(problemId), "iceCandidates");

export const ensureSignalingRoom = async (problemId, startedBy) => {
  const ref = callDocRef(problemId);
  await setDoc(
    ref,
    {
      roomId: getWorkspaceRoomId(problemId),
      problemId,
      active: true,
      callActive: true,
      ...(startedBy ? { startedBy, startedAt: serverTimestamp() } : {}),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
  logger.log(`[CALL] signaling room ensured for ${getWorkspaceRoomId(problemId)}`);
};

export const publishOffer = async (problemId, senderUid, offer) => {
  const ref = callDocRef(problemId);
  await setDoc(
    ref,
    {
      roomId: getWorkspaceRoomId(problemId),
      problemId,
      active: true,
      callActive: true,
      offer: {
        type: offer.type,
        sdp: offer.sdp,
        senderUid,
        createdAt: serverTimestamp(),
      },
      answer: null,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
  logger.log(`[CALL] offer created for ${getWorkspaceRoomId(problemId)}`);
};

export const publishAnswer = async (problemId, senderUid, answer) => {
  const ref = callDocRef(problemId);
  await setDoc(
    ref,
    {
      answer: {
        type: answer.type,
        sdp: answer.sdp,
        senderUid,
        createdAt: serverTimestamp(),
      },
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
  logger.log(`[CALL] answer published for ${getWorkspaceRoomId(problemId)}`);
};

export const publishIceCandidate = async (problemId, senderUid, candidate) => {
  await addDoc(iceCollectionRef(problemId), {
    problemId,
    roomId: getWorkspaceRoomId(problemId),
    candidate: candidate.candidate,
    sdpMid: candidate.sdpMid ?? null,
    sdpMLineIndex: candidate.sdpMLineIndex ?? null,
    senderUid,
    createdAt: serverTimestamp(),
  });
};

export const subscribeToSignalingDoc = (problemId, callback) => {
  return onSnapshot(
    callDocRef(problemId),
    (snap) => {
      callback(
        snap.exists()
          ? {
              id: snap.id,
              ...snap.data(),
            }
          : null
      );
    },
    (error) => {
      console.warn("[CALL] signaling listener error", error);
      callback(null);
    }
  );
};

export const subscribeToIceCandidates = (problemId, callback) => {
  return onSnapshot(
    iceCollectionRef(problemId),
    (snap) => {
      snap.docChanges().forEach((change) => {
        if (change.type === "added") {
          callback({
            id: change.doc.id,
            ...change.doc.data(),
          });
        }
      });
    },
    (error) => {
      console.warn("[CALL] ICE listener error", error);
    }
  );
};

